import styled from "styled-components";

export const Container = styled.div`
    display: flex;
    padding: 16px 32px 32px 32px;
    flex-direction: column;
    align-items: flex-start;
    gap: 40px;
    align-self: stretch;
`;

export const Header = styled.div`
    display: flex;
    flex-direction: column;
    gap: 16px;

    .titulo{
        display: flex;
        justify-content: space-between;
        align-items: center;
        align-self: stretch;
    }
    h1 {
        color: var(--Gray-gray-800, #40444C);
        text-align: center;

        /* text-heading-l-bold */
        font-family: Nunito;
        font-size: 24px;
        font-style: normal;
        font-weight: 700;
        line-height: 150%; /* 36px */
        letter-spacing: -0.24px;
    }

    p {
        align-self: stretch;
        color: var(--Gray-gray-600, #6A717E);

        /* text-paragraph-m */
        font-family: Poppins;
        font-size: 16px;
        font-style: normal;
        font-weight: 400;
        line-height: 150%; /* 24px */
    }
`;

export const BackButton = styled.button`
    display: flex;
    height: 40px;
    padding: 8px 24px;
    justify-content: center;
    align-items: center;
    gap: 8px;
    border-radius: 8px;
    border: 1px solid var(--Primary-brand-500, #EC6643);
    background-color: transparent;
    
    color: var(--Primary-brand-500, #EC6643);
    text-align: center;

    font-family: Poppins;
    font-size: 14px;
    font-style: normal;
    font-weight: 600;
    line-height: 143%;
    letter-spacing: 0.14px;

    transition: background-color 0.2s ease, border-color 0.2s ease, color 0.2s ease;

    /* ícone padrão */
    svg {
        fill: #EC6643;
        transition: fill 0.2s ease;
    }

    &:hover {
        background-color: #EC6643;
        color: #fff;
        cursor: pointer;

        /* ícone no hover */
        svg {
            fill: #fff;
        }
    }
`;



export const Explication = styled.div`
    display: flex;
    align-items: center;
    gap: 40px;
    align-self: stretch;
`;

export const ImageBox = styled.div`
    display: flex;
    flex-direction: column;
    border-radius: 16px;
    padding: 0 0 32px;

    img {
        max-width: 589px;
        height: 334px;
        aspect-ratio: 589/334;
        width: auto;
        border-radius: 8px;
        object-fit: cover;
    }
`;

export const Section = styled.section`
  margin: 32px 0;

  h2 {
    align-self: stretch;
    color: var(--Gray-gray-800, #40444C);

    /* text-heading-m-semi */
    font-family: Poppins;
    font-size: 20px;
    font-style: normal;
    font-weight: 600;
    line-height: 160%; /* 32px */
  }

  p {
    align-self: stretch;
    color: var(--Gray-gray-600, #6A717E);

    /* text-paragraph-m */
    font-family: Poppins;
    font-size: 16px;
    font-style: normal;
    font-weight: 400;
    line-height: 150%; /* 24px */
  }
`;

export const Cards = styled.div`
  display: flex;
  gap: 16px;
  margin-top: 16px;
  flex-wrap: wrap;
`;

export const Card = styled.div`
    display: flex;
    padding: 32px;
    flex-direction: column;
    align-items: flex-start;
    gap: 16px;
    flex: 1 0 0;
    min-width: 260px;
    background: #fff;
    border: 1px solid #ececec;
    border-radius: 12px;
    padding: 20px;


    color: var(--Gray-gray-800, #40444C);

    /* text-paragraph-l-med */
    font-family: Poppins;
    font-size: 18px;
    font-style: normal;
    font-weight: 600;
    line-height: 156%; /* 28.08px */

    // div {
    //     display: flex;
    //     justify-content: center;
    //     align-items: center;
    //     color: var(--Gray-gray-800, #40444C);

    //     /* text-paragraph-l-med */
    //     font-family: Poppins;
    //     font-size: 18px;
    //     font-style: normal;
    //     font-weight: 600;
    //     line-height: 156%; /* 28.08px */
    // }
    
    .cards-renda{
        display: flex;
        flex-direction: column;
        align-items: flex-start;
        gap: 0px;
        align-self: stretch;
        p {
            color: var(--Gray-gray-600, #6A717E);

            /* text-paragraph-m */
            font-family: Poppins;
            font-size: 16px;
            font-style: normal;
            font-weight: 400;
            line-height: 150%; /* 24px */
        }
    }    
`;

export const IconsGrid = styled.div`
  display: flex;
  gap: 16px;
  flex-wrap: wrap;
  margin-top: 20px;
`;

export const IconCard = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 24px;
    flex: 1 0 0;
    min-width: 220px;
    background: #fff;
    padding: 16px;

    .border-icon{
        display: flex;
        padding: 20px;
        align-items: center;
        gap: 10px;

        border-radius: 500px;
        border: 2px solid var(--Gray-gray-200, #C0C3C9);
    }
    
    h4{
        align-self: stretch;
        color: var(--Gray-gray-600, #6A717E);
        text-align: center;

        /* text-paragraph-l */
        font-family: Poppins;
        font-size: 18px;
        font-style: normal;
        font-weight: 400;
        line-height: 156%; /* 28.08px */
    }

`;
